import { NgModule } from 'ng-metadata/core';
import {ActionListService} from './actionList.service';
import {PermalinkService} from './permalinkAction/permalink.service';
import {PrmActionList} from './actionList.directive';
import appConfigModule from '../../appConfig/appConfig.module';
import {PrmActionContainer} from './actionContainer/actionContainer.directive';
import {PrmPrintItem} from './printAction/printItem.directive';
import {PrintItemService} from './printAction/printItem.service';
const uiRouter:string = require('angular-ui-router');
const angularClipboard = require('angular-clipboard');
import {PrmPermalink} from './permalinkAction/permalink.directive';
import {PrmCopyClipboardBtn} from './../../clipboard/copyClipboardBtn.directive';
import {PrmCitation} from './citation/citation.directive';
import {PrmSendEmail} from './sendEmailAction/sendEmail.directive';
import {PushtoService} from './pushto.service';
import {PrmEasybib} from './easyBibAction/easybib.directive';
import {PrmEndnote} from './endNoteAction/endnote.directive';
import {PrmRefworks} from './refworksAction/refworks.directive';
import {PrmExportRis} from './exportRISAction/exportRis.directive';
import {PrmExportBibtex} from './exportBibTexAction/exportBibtex.directive';
import {PrmMendeley} from './mendeleyAction/mendeley.directive';
import {PrmLeganto} from './legantoAction/leganto.directive';
import {PrmExportExcel} from './exportExcelAction/exportExcel.directive';
import {EndNoteService} from "./endNoteAction/endNote.service";
import {EasyBibService} from "./easyBibAction/easyBib.service";
import {RefWorksService} from "./refworksAction/refworks.service";
import {LegantoService} from "./legantoAction/leganto.service";
import {MendeleyService} from "./mendeleyAction/mendeley.service";
import { PrmMendeleyToast } from './mendeleyAction/mendeleyToast/mendeleyToast.directive';
import { MendeleyToastService } from './mendeleyAction/mendeleyToast/mendeleyToast.service';
import {ExportExcelService} from './exportExcelAction/exportExcel.service';
import {ServiceDetailsService} from '../fullView/details/serviceDetails.service';
import {PrmQrCode} from "../topbar/qrCode/qrCode.directive";
import { PrmShare } from './shareAction/share.directive';
import { ShareService } from './shareAction/share.service';
import { PrmExportAll } from './exportAll/exportAll.directive';
import { ExportAllService } from './exportAll/exportAll.service';


//PrmPrintItem, PrmPermalink, PrmCitation, PrmSendEmail, PrmEasybib, PrmEndnote, PrmRefworks, PrmExportRis
@NgModule({
    declarations: [PrmActionContainer,
        PrmActionList,
        PrmCitation,
        PrmCopyClipboardBtn,
        PrmEasybib,
        PrmEndnote,
        PrmExportRis,
        PrmExportBibtex,
        PrmLeganto,
        PrmMendeley,
        PrmMendeleyToast,
        PrmPermalink,
        PrmPrintItem,
        PrmRefworks,
        PrmSendEmail,
        PrmExportExcel,
        PushtoService,
        PrmQrCode,
        PrmShare,
        PrmExportAll
        
    ],
    providers: [
        ServiceDetailsService,
        ActionListService,
        PermalinkService,
        PrintItemService,
        EndNoteService,
        EasyBibService,
        RefWorksService,
        LegantoService,
        MendeleyService,
        MendeleyToastService,
        ExportExcelService,
        ShareService,
        ExportAllService
        ],
    imports:[
        angularClipboard.name,
        appConfigModule.name,
        uiRouter
    ]
})
export class ActionsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/actions.module.ts